function visible(element) {
  if (!element) return false;

  const style =
    window.getComputedStyle(element);

  return (
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    element.getClientRects().length > 0
  );
}

function normalize(value) {
  return String(value || "")
    .replace(/\s+/g, " ")
    .trim();
}

function spreadsheetSafeValue(value) {
  const text = normalize(value);
  const leftTrimmed =
    text.replace(/^[\t\r\n ]+/, "");

  if (/^[=+\-@]/.test(leftTrimmed)) {
    return `'${text}`;
  }

  return text;
}

function csvCell(value) {
  const safe =
    spreadsheetSafeValue(value);

  return `"${safe.replace(
    /"/g,
    '""'
  )}"`;
}

function downloadCsv(lines, filename) {
  const blob = new Blob(
    ["\uFEFF", lines.join("\r\n")],
    { type: "text/csv;charset=utf-8" }
  );

  const href =
    URL.createObjectURL(blob);

  const link =
    document.createElement("a");

  link.href = href;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
}

export function exportVisiblePageCsv({
  filename =
    "wirelesspress-visible-report.csv",
} = {}) {
  const tables = Array.from(
    document.querySelectorAll(
      "main table, table"
    )
  ).filter(visible);

  const lines = [];

  if (tables.length) {
    tables.forEach(
      (table, tableIndex) => {
        if (tableIndex > 0) {
          lines.push("");
        }

        lines.push(
          csvCell(
            `Table ${
              tableIndex + 1
            }`
          )
        );

        Array.from(
          table.querySelectorAll("tr")
        ).forEach((row) => {
          const cells =
            Array.from(
              row.querySelectorAll(
                "th,td"
              )
            );

          if (!cells.length) return;

          lines.push(
            cells
              .map((cell) =>
                csvCell(
                  cell.textContent
                )
              )
              .join(",")
          );
        });
      }
    );
  } else {
    const candidates = Array.from(
      document.querySelectorAll(
        "main h1, main h2, main h3, " +
          "main [class*='metric'], " +
          "main [class*='stat']"
      )
    ).filter(visible);

    lines.push(
      [
        csvCell("Type"),
        csvCell("Visible Value"),
      ].join(",")
    );

    candidates.forEach(
      (element) => {
        const value = normalize(
          element.textContent
        );

        if (!value) return;

        lines.push(
          [
            csvCell(
              element.tagName
            ),
            csvCell(value),
          ].join(",")
        );
      }
    );
  }

  if (!lines.length) {
    throw new Error(
      "No visible report data is available for CSV export."
    );
  }

  downloadCsv(lines, filename);
}
